import * as FileDownloadConstants from './FileDownloadConstants';
import * as RSUConstants from 'Instrument/subfeatures/rsu/RSUConstants';
import { produce, current, original } from "immer";
import { STATUS_COMPLETED, STATUS_FAIL, STATUS_SUCCESS } from 'Common/constants/commonConstants';
import { convertUTCDateTimeToLocalDate } from "Common/components/commonComponents";

// Object.assign is not yet fully supported in all browsers, so we fallback to
// a polyfill
const assign = Object.assign || require('object.assign');

// The initial application state
const initialState = {};

export default function FileDownloadReducer(state = initialState, action) {
    switch (action.type) {
        case FileDownloadConstants.FILE_DOWNLOAD_DEVICE_STATE_ADD: {
            if (state[action.payload]) {
                return state;
            }
            const newState = produce(state, (draft) => {
                draft[action.payload] = {
                    ...draft[action.payload],
                    isFetching: false,
                    isFetched: true,
                    isError: false,
                    errorMsg: "",
                    fileSizeError: false,
                    filesList: [],
                    unsuccessfulDeletes: [],

                    resendProgress: false,
                    resendError: false,
                    resendBtnClickErr:false,
                    nonRsuUsrResendBtnClickErr:false,
                    dltRSUInvalidError:false,
                    rsuUsrResendBtnClickErr:false,

                    deleteProgress: false,
                    deleteError: false,
                    deleteActionType: "",
                    isDeleteAllInitiated: false,
                    showDeleteFilesModal: false,

                    isUploading: false,
                    uploadStatus: {},
                    uploadFailed: false,
                    rsuUploadFailed:false,
                    resendUploadFailed:false,
                    filetype:null
                }
            });
            return assign({}, state, newState);
        }
        case FileDownloadConstants.FILE_DOWNLOAD_DEVICE_STATE_REMOVE: {
            const newState = produce(state, (draft) => {
                if (draft[action.payload]) {
                    delete draft[action.payload];
                }
            });
            return assign({}, newState);
        }
        case FileDownloadConstants.FILE_DOWNLOAD_HISTORY_REQUEST: {
            const newState = produce(state, (draft) => {
                draft[action.payload] = {
                    ...draft[action.payload],
                    isFetching: true,
                    isFetched: false,
                    isError: false,
                    unsuccessfulDeletes: []
                };
            });
            return assign({}, state, newState);
        }
        case FileDownloadConstants.FILE_DOWNLOAD_HISTORY_SUCCESS: {
            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    isFetching: false,
                    isFetched: true,
                    filesList: action.payload.newState,
                    unsuccessfulDeletes: []
                };
            });
            return assign({}, state, newState);
        }
        case FileDownloadConstants.FILE_DOWNLOAD_HISTORY_FAILURE: {
            let authError = false;
            if(action.payload.newState?.errorMsg){
                authError = true
            }
            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    isFetching: false,
                    isFetched: true,
                    isError: true,
                    errorMsg: action.payload.newState?.errorMsg,
                    authError,
                    unsuccessfulDeletes: []
                };
            });
            return assign({}, state, newState);
        }
        case FileDownloadConstants.FILE_DOWNLOAD_UPLOAD_FILE_REQUEST: {
            const newState = produce(state, (draft) => {
                draft[action.instanceId] = {
                    ...draft[action.instanceId],
                    isUploading: true,
                    uploadFailed: false,
                    rsuUploadFailed:false,
                    resendUploadFailed:false,
                    uploadStatus: {}
                };
            });
            return assign({}, state, newState);
        }
        case FileDownloadConstants.FILE_DOWNLOAD_UPLOAD_FILE_SUCCESS: {
            let newEntry = action.payload.newState;
            let newState = produce(state, (draft) => {
                draft[action.payload.instanceId].filesList.unshift(newEntry)
                draft[action.payload.instanceId].isUploading = false;
                draft[action.payload.instanceId].uploadFailed = false;
                draft[action.payload.instanceId].rsuUploadFailed = false;
                draft[action.payload.instanceId].resendUploadFailed = false;
                draft[action.payload.instanceId].uploadStatus = {};
                draft[action.payload.instanceId].filetype='GENERIC'
            });
            return assign({}, state, newState);
        }
        case FileDownloadConstants.FILE_DOWNLOAD_UPLOAD_FILE_INPROGRESS: {
            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    isUploading: true,
                    uploadStatus: action.payload.newState
                };
            });
            return assign({}, state, newState);
        }
        case FileDownloadConstants.FILE_DOWNLOAD_UPLOAD_INPROG_COMPLETE: {
            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    uploadStatus: {
                        estimatedTime: "Completed",
                        percent: 100
                    }
                };
            });
            return assign({}, state, newState);
        }
        case FileDownloadConstants.FILE_DOWNLOAD_UPLOAD_FILE_FAILURE: {
            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    isUploading: false,
                    uploadFailed: true,
                    rsuUploadFailed:false,
                    resendUploadFailed:false,
                    errorMsg: action.payload.newState?.message,
                    uploadStatus: {}
                };
            });
            return assign({}, state, newState);
        }

        case FileDownloadConstants.RSU_FILE_INPROGRESS_CHECK: {
            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    isUploading: false,
                    uploadFailed:false,
                    rsuUploadFailed: true,
                    resendUploadFailed:false,
                    errorMsg: action.payload.newState?.message,
                    uploadStatus: {}
                };
            });
            return assign({}, state, newState);
        }
        case FileDownloadConstants.RESEND_FILE_INPROGRESS_CHECK: {
            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    isUploading: false,
                    uploadFailed:false,
                    rsuUploadFailed: false,
                    resendUploadFailed:true,
                    errorMsg: action.payload.newState?.message,
                    uploadStatus: {}
                };
            });
            return assign({}, state, newState);
        }

        case FileDownloadConstants.FILE_DOWNLOAD_RESEND_FILE_REQUEST: {
            const newState = produce(state, (draft) => {
                draft[action.payload] = {
                    ...draft[action.payload],
                    resendProgress: true,
                    resendError: false,
                };
            });
            return assign({}, state, newState);
        }

        case FileDownloadConstants.FILE_DOWNLOAD_RESEND_INVALID : {
            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    resendBtnClickErr: true
                };
            });
            return assign({}, state, newState);
        }

        case FileDownloadConstants.NON_RSU_USER_RESEND_INVALID : {
            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    nonRsuUsrResendBtnClickErr: true
                };
            });
            return assign({}, state, newState);
        }

        case FileDownloadConstants.INVALID_SELECT_MULTIPLE_RSU_FILE : {
            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    rsuUsrResendBtnClickErr: true
                };
            });
            return assign({}, state, newState);
        }



        case FileDownloadConstants.FILE_DOWNLOAD_RESEND_FILE_SUCCESS: {
            let updatedList = action.payload.newState;
            let newState = produce(state, draft => {
                draft[action.payload.instanceId].filesList.map(elem => {
                    updatedList?.map(uelem => {
                        if (uelem.reqID == elem.reqID) {
                            elem.status = uelem.status;
                            elem.updateDateTime = uelem.updateDateTime;
                            elem.instLocation = uelem.instLocation;
                            elem.topicListener = uelem.topicListener;
                        }
                    })
                })
                draft[action.payload.instanceId].resendProgress = false;
                draft[action.payload.instanceId].resendError = false;
            });
            return assign({}, state, newState);
        }

        case FileDownloadConstants.FILE_DOWNLOAD_RESEND_FILE_FAILURE: {
            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    resendProgress: false,
                    errorMsg: action.payload.newState.message,
                    resendError: true,
                };
            });
            return assign({}, state, newState);
        }

        case FileDownloadConstants.FILE_DOWNLOAD_DELETE_FILE_REQUEST: {
            let filesToDelete = action.payload.filesToDelete;
            let updatedFilesList = state[action.payload.instanceId].filesList.map(listItem => assign({}, listItem, {
                status: filesToDelete.some(file => listItem.reqID == file) ? "Deleting": listItem.status
            }));
            return assign({}, state, {
                deleteProgress: true,
                deleteError: false,
                filesList: updatedFilesList,
                unsuccessfulDeletes: []
            });
        }
        case FileDownloadConstants.FILE_DOWNLOAD_DELETE_FILE_SUCCESS: {
            let updatedList = action.payload.newState;
            let newState = produce(state, draft => {
                let draftFilesList = draft[action.payload.instanceId].filesList
                updatedList?.map(uelem => {
                    if (uelem.status.toLowerCase() == STATUS_SUCCESS.toLowerCase()) {
                        draftFilesList = draftFilesList.filter(elem => elem.reqID != uelem.reqID);
                    } else {
                        draft[action.payload.instanceId].unsuccessfulDeletes.push(draft[action.payload.instanceId].filesList.find(elem => elem.reqID == uelem.reqID))
                    }
                })
                draft[action.payload.instanceId].filesList = draftFilesList;
                draft[action.payload.instanceId].deleteProgress = false;
                draft[action.payload.instanceId].deleteError = false;
                draft[action.payload.instanceId].deleteActionType = "";

            });
            return assign({}, state, newState);
        }
        case FileDownloadConstants.FILE_DOWNLOAD_DELETE_FILE_FAILURE: {
            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    deleteProgress: false,
                    errorMsg: action.payload.newState.message,
                    deleteError: true
                };
            });
            return assign({}, state, newState);
        }
        case FileDownloadConstants.FILE_DOWNLOAD_RESET_ERRORS: {
            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    isError: false,
                    deleteError: false,
                    resendError: false,
                    uploadFailed: false,
                    rsuUploadFailed:false,
                    resendUploadFailed:false,
                    errorMsg: "",
                    fileSizeError: false,
                    deleteActionType: "",
                    resendBtnClickErr: false,
                    nonRsuUsrResendBtnClickErr: false,
                    dltRSUInvalidError:false,
                    rsuUsrResendBtnClickErr:false,
                };
            });
            return assign({}, state, newState);
        }
        case FileDownloadConstants.FILE_DOWNLOAD_SERVICE_BUS_UPDATE: {
            let newState = produce(state, draft => {
                draft[action.payload.instanceId].filesList?.map(elem => {
                    if (elem.topicListener && elem.topicListener.subscription === action.payload.newState.RequestId) {
                        elem.instLocation = action.payload.newState.PathOnDisk;
                        if(action.payload.newState.FileType){
                            if(FileDownloadConstants.FILE_TYPE_GENERIC.toLowerCase() == action.payload.newState.FileType.toLowerCase() || (FileDownloadConstants.FILE_TYPE_RSU.toLowerCase() == action.payload.newState.FileType.toLowerCase() && FileDownloadConstants.FILE_DOWNLOAD_STATUS_COMPLETED.toLowerCase() != action.payload.newState.Status.toLowerCase())){
                                elem.status = action.payload.newState.Status;
                            }
                        }else{
                            elem.status = action.payload.newState.Status;
                        }
                        elem.updateDateTime = action.payload.newState.StatusDateTimeUtc;
                        if ((action.payload.newState.Status.toLowerCase() == STATUS_COMPLETED && FileDownloadConstants.FILE_TYPE_RSU != action.payload.newState.FileType) 
                                || action.payload.newState.Status.toLowerCase().includes(STATUS_FAIL) ) {
                            elem.topicListener = undefined;
                        }
                    }
                })
            })
            return assign({}, state, newState);
        }
        case FileDownloadConstants.RSU_SERVICE_BUS_MSG_UPDATE: {
            let newState = produce(state, draft => {
                draft[action.payload.instanceId].filesList?.map(elem => {
                    let statusDtls = action.payload.newState.Details; 
                    if (elem.topicListener && elem.topicListener.subscription === action.payload.newState.JobID 
                            && (!statusDtls?.toLowerCase().includes(RSUConstants.RSU_MNFST_FILE_NAME) || (statusDtls?.toLowerCase().includes(RSUConstants.RSU_MNFST_FILE_NAME) && (action.payload.newState.Status.toLowerCase() == RSUConstants.RSU_STATUS_DWNLD_FAIL || action.payload.newState.Status.toLowerCase() == RSUConstants.RSU_STATUS_INSTL_FAIL)))) {
                        elem.details = statusDtls;
                        elem.status = action.payload.newState.Status;
                        // elem.status = (action.newState.Status.toLowerCase() == FileDownloadConstants.RSU_STATUS_INSTL_SCHDLD) ? action.newState.Status + ' ' + action.newState.Details : action.newState.Status;
                        if(statusDtls!=null && statusDtls!="" && (action.payload.newState.Status.toLowerCase() == RSUConstants.RSU_STATUS_DWNLD_SUCCD || action.payload.newState.Status.toLowerCase() == RSUConstants.RSU_STATUS_DWNLD_STARTED)){
                            elem.instLocation = statusDtls;
                        }
                        elem.updateDateTime = action.payload.newState.DateTimeUTC;
                        if (RSUConstants.RSU_FINAL_STATUSES.split(",").includes(action.payload.newState.Status.toLowerCase())) {
                            elem.topicListener = undefined;
                        }
                    }
                })
            })
            return assign({}, state, newState);
        }
        case FileDownloadConstants.FILE_DOWNLOAD_DELETE_MODAL_CTRL: {
            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    showDeleteFilesModal: action.payload.newState?.value,
                    deleteActionType: action.payload.newState?.deleteActionType,
                };
            });
            return assign({}, state, newState);
        }

        case FileDownloadConstants.DELETE_RSU_INVALID_CTRL: {
            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    dltRSUInvalidError : action.payload.newState
                };
            });
            return assign({}, state, newState);
        }

        case FileDownloadConstants.FILE_DOWNLOAD_SIZE_LIMIT_EXCEED: {
            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    errorMsg: FileDownloadConstants.FILE_DOWNLOAD_SIZE_LIMIT_ERROR + action.payload.newState,
                    fileSizeError: true,
                    isUploading: false,
                    uploadStatus: {}
                };
            });
            return assign({}, state, newState);
        }
        case FileDownloadConstants.FILE_DOWNLOAD_DELETE_ALL_FILES_REQUEST: {
            let newState = produce(state, draft => {
                let rsuFilesList = [], genericFilesList = [];
                draft[action.payload].filesList.map(file => {
                    if(file.fileType.toLowerCase() == FileDownloadConstants.FILE_TYPE_RSU.toLowerCase()){
                        rsuFilesList.push(file);
                    }else{
                        genericFilesList.push(file);
                    }
                });
                draft[action.payload].deleteError = false,
                draft[action.payload].unsuccessfulDeletes = [],
                draft[action.payload].deleteActionType = "",
                draft[action.payload].isDeleteAllInitiated = true,
                draft[action.payload].deletedRows = genericFilesList,
                draft[action.payload].filesList = rsuFilesList;
            });
            return assign({}, state, newState);
        }
        case FileDownloadConstants.FILE_DOWNLOAD_DELETE_ALL_FILES_SUCCESS: {
            let updatedList = action.payload.newState;
            let newState = produce(state, draft => {
                let draftFilesList = [];
                updatedList?.map(uelem => {
                    if (uelem.status.toLowerCase() != STATUS_SUCCESS.toLowerCase()) {
                        draftFilesList.push(draft[action.payload.instanceId].deletedRows.find(elem => elem.reqID == uelem.reqID))
                    }
                });
                draft[action.payload.instanceId].filesList.map(file => {
                    if(file.fileType.toLowerCase() == FileDownloadConstants.FILE_TYPE_RSU.toLowerCase()){
                        draftFilesList.push(file);
                    }
                });
                draft[action.payload.instanceId].filesList = draftFilesList;
                draft[action.payload.instanceId].deleteProgress = false;
                draft[action.payload.instanceId].deleteError = false;
                draft[action.payload.instanceId].deletedRows = [];
                draft[action.payload.instanceId].deleteActionType = "";
            });
            return assign({}, state, newState);
        }
        case FileDownloadConstants.FILE_DOWNLOAD_DELETE_ALL_FILES_FAILURE: {
            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    deleteProgress: false,
                    errorMsg: action.payload.newState.message,
                    deleteError: true
                };
            });
            return assign({}, state, newState);
        }
        case FileDownloadConstants.FILE_DOWNLOAD_DELETE_ALL_FILES_RESET_INIT: {
            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    isDeleteAllInitiated: false
                };
            });
            return assign({}, state, newState);
        }

        case RSUConstants.RSU_FILE_UPLOAD_SUCCESS : {
            let newEntry = action.payload.newState
            let newState = produce(state, (draft) => {
                draft[action.payload.instanceId].filesList.unshift(newEntry)
                draft[action.payload.instanceId].isUploading = false;
                draft[action.payload.instanceId].uploadFailed = false;
                draft[action.payload.instanceId].rsuUploadFailed = false;
                draft[action.payload.instanceId].resendUploadFailed = false;
                draft[action.payload.instanceId].uploadStatus = {},
                draft[action.payload.instanceId].filetype='RSU'
            });
            return assign({}, state, newState);
        }

        case RSUConstants.RSU_FILE_UPLOAD_FAILURE : {
            const newState = produce(state, (draft) => {
                draft[action.payload.instanceId] = {
                    ...draft[action.payload.instanceId],
                    isUploading: false,
                    uploadFailed: true,
                    rsuUploadFailed:false,
                    resendUploadFailed:false,
                    errorMsg: action.payload.newState?.message,
                    uploadStatus: {}
                };
            });
            return assign({}, state, newState);
        }
        default:
            return state;
    }
}